// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"CategoryList-module--categoryList--1TTUC","categoryListItem":"CategoryList-module--categoryListItem--2UgTy typography-module--responsiveTitle3--3gljT"};